import { Link } from 'react-router-dom';

const LOGO_URL = '/assets/hero/logo.png';

const Footer = () => {
  return (
    <footer className="bg-[#3E2723] text-white py-12 px-6" data-testid="app-footer">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <div className="flex flex-col items-start">
            <div className="flex items-center space-x-3 mb-4">
              <img src={LOGO_URL} alt="Ourmend Logo" className="h-10 w-10 object-contain" />
              <div>
                <span className="text-xl font-bold text-amber-200">Ourmend</span>
                <p className="text-xs text-amber-100/70 font-bold">Community Healers. Cultural Care.</p>
              </div>
            </div>
            <p className="text-sm text-stone-300 leading-relaxed">
              Connecting people of color with trusted healers who understand their lived experience.
            </p>
          </div>

          <div>
            <h4 className="font-bold text-amber-200 mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm text-stone-300">
              <li><Link to="/browse" className="hover:text-amber-200 transition-colors" data-testid="footer-browse-link">Browse Healers</Link></li>
              <li><Link to="/join-as-healer" className="hover:text-amber-200 transition-colors" data-testid="footer-join-link">Join As A Healer</Link></li>
              <li><Link to="/contact" className="hover:text-amber-200 transition-colors" data-testid="footer-contact-link">Contact Us</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-amber-200 mb-4">Legal</h4>
            <ul className="space-y-2 text-sm text-stone-300">
              <li><Link to="/privacy" className="hover:text-amber-200 transition-colors" data-testid="footer-privacy-link">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-amber-200 transition-colors" data-testid="footer-terms-link">Terms of Service</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-stone-600 pt-6 text-center text-sm text-stone-400">
          <p>&copy; {new Date().getFullYear()} Ourmend. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
